import { api } from "./api";

export const todayAttendance = async (addUrl = "") => {
  return await api.get(`hostel/student/attendance/today?${addUrl}`);
};
export const monthlyAttendanceList = async (addUrl = "") => {
  return await api.get(`hostel/student/attendance/month/list?${addUrl}`);
};
export const dayWiseAttendanceList = async (addUrl = "") => {
  return await api.get(`hostel/student/attendance/list?${addUrl}`);
};

export const attendanceAdd = async (data) => {
  return await api.post("hostel/student/attendance/post", data);
};
